<template>
	<div class="h-full w-full overflow-auto p-14 pt-24">
		<template v-if="sessionStore.activePriceBook">
			<!-- Show/hide toggle -->
			<div class="mb-6 flex justify-start">
				<button
					type="button"
					@click="showTerms = !showTerms"
					:class="[
						'flex items-center gap-1 transition-colors',
						showTerms
							? 'text-primary-600 hover:text-primary-700'
							: 'text-primary-200 hover:text-primary-300',
					]"
				>
					<component
						:is="showTerms ? EyeIcon : EyeSlashIcon"
						class="size-6"
					/>
				</button>
			</div>
			<!-- Replace component when encryption status changes due to broken reactivity -->
			<PlanPaymentOptions
				v-for="(plan, index) in plans"
				:key="plan.id + plan.encryptionStatus"
				:plan="plan"
				:index="index"
				:show-terms="showTerms"
				class="mb-15"
			/>
		</template>
		<template v-else>
			{{ t('paymentOptionsSlide.loadingPriceBook') }}
		</template>
	</div>
</template>

<script setup lang="ts">
import PlanPaymentOptions from '../merchandise/PlanPaymentOptions.vue'
import { usePresentationLocale } from '@/i18n'
import { useSessionStore } from '@/stores/session'
import { EyeIcon, EyeSlashIcon } from '@heroicons/vue/24/solid'
import { computed, ref } from 'vue'

const { t } = usePresentationLocale()
const sessionStore = useSessionStore()
const plans = computed(() => sessionStore.activePlans)
const showTerms = ref(false)
</script>
